module.exports = __webpack_public_path__ + "img/hand-left.1d7f21fc.png";